import { cookieStorage, createConfig, createStorage, WagmiPlugin } from '@wagmi/vue';
import { coinbaseWallet, metaMask, walletConnect } from '@wagmi/vue/connectors';
import { defineNuxtPlugin } from '#app';
import { chains, createTransports } from '~/service/EVM/config';
import { useNuxtApp } from '#imports';

const appName = import.meta.env.VITE_PROJECT;
const metamaskMeta = {
    name: appName,
    url: import.meta.env.VITE_DOMEN_URL
};

export default defineNuxtPlugin({
    name: 'wagmiplugin',
    parallel: true,
    dependsOn: [
        'tanstack',
        'pinia'
    ],
    async setup(nuxtApp) {
        // const runtimeConfig = useRuntimeConfig();
        //
        // const getJWTTokenXsolla = () => {
        //     return localStorage.getItem('xsolla_metaframe_token');
        // };

        const { $evmCore } = useNuxtApp();

        const transports = createTransports($evmCore.eventEmitter);

        const alertStore = useAlertsStore();

        const config = createConfig({
            ssr: true,
            storage: createStorage({
                storage: cookieStorage
            }),
            chains,
            transports,
            connectors: [
                // zksyncConnector,
                metaMask({
                    dappMetadata: metamaskMeta,
                    useDeeplink: false,
                    checkInstallationOnAllCalls: false,
                    checkInstallationImmediately: false
                }),
                coinbaseWallet({
                    appName,
                    preference: {
                        options: 'eoaOnly'
                    }
                }),
                // zksyncSsoConnector({
                //     metadata: {
                //         icon: runtimeConfig.public.wallets.xsolla.icon,
                //         name: runtimeConfig.public.wallets.xsolla.name,
                //         configData: {
                //             token: getJWTTokenXsolla() || ''
                //         }
                //     },
                //     authServerUrl: 'https://xsollazk.com/wallet-demo/'
                // }),
                walletConnect({
                    projectId: import.meta.env.VITE_ID_WALLET_CONNECT
                })
            ]
        });

        const { eventEmitter } = useEVMCore();

        eventEmitter.on('rpcError', ({
            onSuccess: val => alertStore.add({
                title: 'RPC Error',
                critical: true,
                status: 'type.error',
                description: val
            }),
            key: 'wagmiPlugin'
        }));

        nuxtApp.vueApp.use(
            WagmiPlugin,
            { config }
        );
        // });
    }
});
